import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { UpArrowGreen, UpArrowInactive } from "../../assets/Icon/ArrowIcon";
import ActiveInactiveModal from "../../pages/clients/ActiveInactiveClientModal";
import ActiveInactiveClientModal from "../../pages/clients/ActiveInactiveClientModal";

interface StatusData {
  rowstatus?: boolean;
  agentId?: number;
}

const AccountStatusButton = ({ rowstatus, agentId }: StatusData) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(
    rowstatus ? "Active" : "Inactive"
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
    handleClose();
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        sx={{
          borderRadius: "24px",
          border: "none",
          color: currentStatus === "Active" ? "#4CAF50" : "#F44336",
          backgroundColor:
            currentStatus === "Active" ? "#4CAF502E" : "#F443362E",
          "&:hover": {
            backgroundColor:
              currentStatus === "Active" ? "#4CAF5045" : "#F4433645",
          },
        }}
        style={{ width: "120px", height: "35px" }}
        endIcon={
          <>
            {currentStatus === "Active" ? (
              <UpArrowGreen />
            ) : (
              <UpArrowInactive />
            )}
          </>
        }
        onClick={handleClick}
      >
        {currentStatus}
      </Button>

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem
          onClick={handleOpenModal}
          disabled={currentStatus === "Active"}
        >
          Active
        </MenuItem>
        <MenuItem
          onClick={handleOpenModal}
          disabled={currentStatus === "Inactive"}
        >
          Inactive
        </MenuItem>
      </Menu>

      <ActiveInactiveClientModal
        open={isModalOpen}
        handleClose={handleCloseModal}
        id={agentId}
        status={currentStatus}
        onSuccess={() => {
          setCurrentStatus(currentStatus == "Active" ? "Inactive" : "Active");
        }}
      />
    </>
  );
};

export default AccountStatusButton;
